import { useEffect, useState } from 'react'

/**
 * Subskrypcja media query z SSR-bezpiecznym startem.
 * Zwraca `false` zanim `window` istnieje (nie renderujemy na serwerze,
 * ale testy i SW prerender potrafią tu wejść bez `window`).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches)
    setMatches(mql.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/**
 * `prefers-reduced-motion: reduce`.
 *
 * Projekt wymaga obsługi tej preferencji, a nie tylko wyłączenia animacji
 * wizualnie — programowe przewijanie kalendarza musi być natychmiastowe,
 * nie „smooth", bo dla części osób płynne przesuwanie ekranu wywołuje
 * zawroty głowy (WCAG 2.3.3 Animation from Interactions).
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)')
}

/** Odpowiednik breakpointu `lg` z tailwind.config.ts. */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)')
}
